import { useSidebar } from "@cmde/shadcn";

export function useSidebarExpanded() {
  const sidebar = useSidebar();
  const isExpanded =
    sidebar.isMobile ? sidebar.openMobile : sidebar.state === "expanded";

  return { ...sidebar, isExpanded };
}
